<template>
	<div>
		<div class="subtitle">{{ title }}</div>
		<div>
			<div class="field">
				<label class="label">{{ $t('questions_header.category') }}</label>
				<div class="control">
					<v-select
						class="panel-select header"
						v-model="selectedQuestionGroup"
						:options="questionGroups"
						:placeholder="$t('questions_header.select_type_placeholder')"
						:allowEmpty="false"
						:internalSearch="true"
						:showLabels="false"
						@search-change="searchGroups"
						@select="changeQuestionGroup"
						track-by="id"
						label="name"
					>
						<span slot="noResult">{{ $t('questions_header.no_results') }}</span>
						<span
							slot="caret"
							slot-scope="{ toggle }"
							class="caret"
							@mousedown.prevent.stop="toggle()"
						><i class="fas fa-caret-down caret-inner"></i
						></span>
					</v-select>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		questionGroups: Array,
		title: String
	},
	data() {
		return {
			selectedQuestionGroup: { questions: [] }
		};
	},
	methods: {
		changeQuestionGroup(questionGroup) {
			this.$emit('change', questionGroup);
		},
		searchGroups(value) {
			this.$emit('searchGroups', value);
		}
	},
	created() {
		this.selectedQuestionGroup = this.questionGroups[0];
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";

.control {
  display: inline-block;
  .panel-select {
    max-width: 300px;
    width: calc(100vw - 123px);
  }
}

.field {
  border-bottom: 1px solid $lightest-grey;
  padding-bottom: 15px;
  margin-bottom: 15px;
  margin: 10px;
}
.label {
  font-size: 12px;
}
.subtitle {
  min-width: 130px;
  max-width: 200px;
  padding-top: 10px;
  margin-bottom: 0.5rem !important;
  font-weight: 600;
}
.button.is-static {
  border-radius: 1px;
  background-color: #fcfcfc;
  border-color: $multiselect-border-color;
  font-size: 18px;
  color: $dark;
  height: 40px;
  padding-top: 6px;
}
</style>

<style lang="scss">
@import "@/assets/colors.scss";

.multiselect.panel-select.header {
  .caret {
    background-color: #fcfcfc;
  }
  .multiselect__tags {
    background-color: white;

    .multiselect__single,
    .multiselect__input {
      background-color: white;
    }
  }
  .multiselect__content {
    background: white;
  }
}
</style>
